<ng-container *ngIf="(loading$ | async) !== true && showFreeTrialStep">
	<h1
		translate="welcome-dialog-free-trial-title"
		[translateParams]="{name: data.user.first_name}">
	</h1>
	<video
		controls
		autoplay
		muted
		playsinline
		controlsList="nodownload"
		poster="https://staticassets.goreact.com/IntroductoryVideoShortVersion-FinalThumbnailTheFinalSeason-Part3-Special2.png"
		[attr.aria-label]="'welcome-dialog-free-trial-video-aria-label' | translate">
		<source src="https://staticassets.goreact.com/IntroductoryVideoShortVersion-Final.mp4" type="video/mp4">
		<span translate="welcome-dialog-free-trial-video-error"></span>
	</video>
	<div class="video-instruction"
		translate="welcome-dialog-free-trial-video-unforced-context">
	</div>
</ng-container>

<ng-container *ngIf="(loading$ | async) !== true && !showFreeTrialStep">
	<mat-icon class="ficon-app-checkmark-circle-outline"></mat-icon>
	<h1
		translate="welcome-dialog-all-set"
		[translateParams]="{name: data.user.first_name}">
	</h1>
	<div id="welcome-body"
		 translate="{{showSelfPayStep ? 'welcome-dialog-license' : 'welcome-dialog-body'}}"
		 [translateParams]="{numDays: data.numDays}">
	</div>
</ng-container>

<button [class]="showFreeTrialStep ? 'primary-btn close-btn' : 'primary-btn'"
		type="button"
		id="welcome-close"
		(click)="proceed()"
		data-cy="welcome-modal_start-btn"
		[style.visibility]="(loading$ | async) ? 'hidden' : 'visible'"
		[attr.aria-label]="showFreeTrialStep ? ('common_close' | translate) : null">
	<span translate="{{showFreeTrialStep ? 'common_close' : (showSelfPayStep ? 'common_continue' : 'welcome-dialog-start-button')}}"></span>
	<span *ngIf="loading$ | async"
		  class="ficon-spinner ficon-spin"
		  aria-live="polite"
		  [attr.aria-label]="'common_loading'| translate">
    </span>
</button>
